var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('AdvicesArticleModule',{attrs:{"module-data":_vm.moduleData,"data-luko-tracking":"Guide_uid"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }